var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-header',{staticClass:"appHeader"},[_c('LOGO'),_c('NavDropdown'),_c('HeaderNav',{attrs:{"navData":_vm.headerNavs,"activeMenu":_vm.activeRoute},on:{"click":_vm.goRoute,"close":_vm.onCloseRoute}}),_c('ExpiredReminder'),_c('AlarmIcon'),_c('HeaderMore'),_c('Fullscreen'),_c('UrgentAlarm'),_c('cotton-picker-alarm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }